<app-button class="unmapped-btn" [buttonSize]="'small small-sm'">
    <mat-checkbox [(ngModel)]="data" (change)="selectAll($event)" class="me-2"></mat-checkbox>
    Select All
</app-button>